import { getCentresOfMeBasicApi } from 'api/user';
import { getAllCustom } from 'redux/crudCreatorCustom/actions';

export const MODEL_NAME = 'centresOfMeBasic';

export const getCentresOfMeBasic = getAllCustom(
  MODEL_NAME,
  getCentresOfMeBasicApi,
);
